import "./Main.scss"

const Card = ({ data }) => {
    return (
        <div className="main">
            {data.map(({ id, title, date, desc, image }) => (
                <div className="card" key={id}>
                    <img src={image} alt="" width="300px" />
                    <div className="title">{title}</div>
                    <div className="desc">{desc}</div>
                    <div className="date">{date}</div>
                </div>
            ))}
        </div>
    );
};

export default Card



